import http from 'infra/http';
import { useQuery } from "react-query";
import { AssuntoMensagemItem } from "../typings";

function useAssuntosMensagens() {
  return useQuery([`/v1/mensagens/assuntos`], async () => {
    const {data} = await http.get<AssuntoMensagemItem[]>('v1/mensagem/assuntos');

    return data;
  });
}

export default useAssuntosMensagens;
